import Component from './ng_applicant_table.vue'
export default Component
